import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import { BRAND, COMPANY, FOOTER, LOGO, SOCIAL } from "../../lib/content";
import { TikTokIcon } from "./TikTokIcon";

const SOCIAL_ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  linkedin: Linkedin,
  youtube: Youtube,
  tiktok: TikTokIcon
};

// Enquanto os perfis não existirem, `url` fica vazia e a faixa inteira some — link
// social quebrado é pior que link ausente.
const socialLinks = SOCIAL.filter((s) => s.url);

export const Footer = () => (
  <footer className="relative border-t border-white/10 py-16" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <a href="#top" className="flex items-center gap-3">
            <img
              src={LOGO}
              alt={BRAND.name}
              width="36"
              height="36"
              loading="lazy"
              decoding="async"
              className="h-9 w-9 object-contain"
            />
            <span className="font-display text-2xl font-bold tracking-tight">{BRAND.name}</span>
          </a>
          <p className="mt-5 max-w-sm text-white/50 leading-relaxed">{FOOTER.tagline}</p>
          <a
            href={`mailto:${FOOTER.email}`}
            className="mt-6 inline-block font-display text-xl md:text-2xl font-bold text-white hover:text-bf-yellow transition-colors duration-200"
            data-testid="footer-email"
          >
            {FOOTER.email}
          </a>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/40">Empresa</h4>
          <p className="mt-5 text-sm text-white/65 leading-relaxed">
            {COMPANY.legalName}
            <br />
            CNPJ {COMPANY.taxId}
          </p>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/40">Endereço</h4>
          <address className="mt-5 not-italic text-sm text-white/65 leading-relaxed">
            {COMPANY.address.street}
            <br />
            {COMPANY.address.district}, {COMPANY.address.city}
          </address>
        </div>
      </div>

      {socialLinks.length > 0 && (
        <div className="mt-12 flex md:justify-end gap-3">
          {socialLinks.map((s) => {
            const Icon = SOCIAL_ICONS[s.icon];
            return (
              <a
                key={s.name}
                href={s.url}
                aria-label={s.name}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 hover:text-black hover:bg-bf-yellow hover:border-bf-yellow transition-colors duration-200"
              >
                <Icon className="h-[18px] w-[18px]" />
              </a>
            );
          })}
        </div>
      )}

      <div className="mt-14 flex flex-col md:flex-row items-center justify-between gap-4 border-t border-white/10 pt-8 text-sm text-white/40">
        <p>© {FOOTER.year} {BRAND.name}. Todos os direitos reservados.</p>
        <div className="flex gap-6">
          <a href="/privacidade.html" className="hover:text-white/70 transition-colors">Política de Privacidade</a>
          <a href="/termos.html" className="hover:text-white/70 transition-colors">Termos de Uso</a>
        </div>
      </div>
    </div>
  </footer>
);
